import { Platform, AsyncStorage } from 'react-native';
import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { VASCO_FLOW, CHANNEL_TYPES } from '../constants';

function getLanguage(selLanguage) {
  const dashIndex = selLanguage.indexOf('-');
  if (dashIndex >= 0) {
    if (selLanguage.startsWith('zh')) {
      return (selLanguage.substring(dashIndex + 1, selLanguage.length)).toLowerCase();
    }
    return selLanguage.substring(0, dashIndex);
  }
  return selLanguage;
}

export default () => {
  return muster()
    .path('resetcode.requestResetCode', {
      call: async ({ req }, { get, set }) => {
        const username = req.args[0];
        await set('auth.userId', username);

        const email = req.args[1];
        const platform = Platform.OS;
        const [messages] = await getValues(get('i18n.messages'));

        const selectedLanguageCode = await AsyncStorage.getItem('SelectedLanguageCode');
        const languageCode =
          selectedLanguageCode != null ? getLanguage(selectedLanguageCode) : null;
        const langCode = languageCode == null ? 'en' : languageCode;

        await set('resetcode.showResetCodePage', true);
        await set('resetcode.wrongUserPassword', '');
        const randomString = 'random' + Math.round(Math.random() * 100);
        const [response] = await
          getValues(
            get(`roster.ebanking.resetcode.requestResetCode["${username}"]["${email}"]["${platform}"]["${langCode}"]["${randomString}"]`)
          );

        const responseObject = JSON.parse(response);
        const isReturnCodeZero = responseObject.returnCode;
        if (isReturnCodeZero === 0) {
          // await set('resetcode.verifyingUsernameAndEmail', false);
          await set('resetcode.resetCodeID', responseObject.resetCodeId);
        } else if (isReturnCodeZero === 700) {
          console.log("setting wrongUserPassword message");
          await set('resetcode.wrongUserPassword', messages['app.reset.resetCode.infoMessage']);
        }
        else if (isReturnCodeZero === -1) {
          await set('resetcode.wrongUserPassword', messages['app.reset.resetCode.technicalError']);
        }
      },
    })

    .path('resetcode.verifyResetCode', {
      call: async ({ req }, { get, set, call }) => {
        await set('resetcode.verifyingResetCode', true);

        const [messages] = await getValues(get('i18n.messages'));
        const resetCodeString = 'resetCode-';
        const resetCodeValue = resetCodeString + req.args[0];
        let [resetCodeID] = await getValues(get('resetcode.resetCodeID'));
        resetCodeID = resetCodeString + resetCodeID;
        const channel = CHANNEL_TYPES.WEB;
        const response = await
          getValues(
            get(`roster.ebanking.resetcode.verifyResetCode["${resetCodeID}"]["${resetCodeValue}"]["${channel}"]`)
          );
        const responseObject = JSON.parse(response);
        const isReturnCodeZero = responseObject.returnCode;
        if (isReturnCodeZero === 0) {
          await set('resetcode.verifyingResetCode', false);
          await set('resetcode.errorText', null);
          await set('auth.authHeader', responseObject.jwt);
          await set('auth.vascoFlow', VASCO_FLOW.resetPassword);
          // await set('auth.authorised', true);
          call('rsa.changePage', '/reset-password');
        } else {
          await set('resetcode.verifyingResetCode', false);
          const returnCode = isReturnCodeZero;
          if (returnCode === -1) {
            await set('resetcode.wrongResetCodeAttemptCount', responseObject.wrongAttemptCount);
          } else if (returnCode === 705) {
            await set('resetcode.attemptCountHasExceeded', true);
            await set('resetcode.errorText', messages['app.reset.resetCode.maxAttempt']);
          }
        }
      },
    })

    .path('resetcode.resendResetCode', {
      call: async ({ req }, { get, set }) => {
        const resetCodeString = 'resetCode-';
        let [resetCodeID] = await getValues(get('resetcode.resetCodeID'));
        resetCodeID = resetCodeString + resetCodeID;

        const selectedLanguageCode = await AsyncStorage.getItem('SelectedLanguageCode');
        const languageCode =
          selectedLanguageCode != null ? getLanguage(selectedLanguageCode) : null;
        const langCode = languageCode == null ? 'en' : languageCode;

        const randomString = 'random' + Math.round(Math.random() * 100);
        const response = await
          getValues(
            get(`roster.ebanking.resetcode.resendResetCode["${resetCodeID}"]["${langCode}"]["${randomString}"]`)
          );
        const responseObject = JSON.parse(response);
        const isReturnCodeZero = responseObject.returnCode;
        if (isReturnCodeZero === 0) {
          await set('resetcode.resetCodeID', responseObject.resetCodeId);
        }
        await set('resetcode.attemptCountHasExceeded', false);
        await set('resetcode.wrongResetCodeAttemptCount', 0);
        await set('resetcode.errorText', null);
      },
    })

    .path('resetcode.changePassword', {
      call: async ({ req }, { get, set }) => {
        const tokenString = 'token-';
        const passwordString = 'pass-';
        const token = tokenString + req.args[0];
        const newCryptoPassword = passwordString + req.args[1];
        const [userId] = await getValues(get('auth.userId'));
        const [messages] = await getValues(get('i18n.messages'));

        const selectedLanguageCode = await AsyncStorage.getItem('SelectedLanguageCode');
        const languageCode =
          selectedLanguageCode != null ? getLanguage(selectedLanguageCode) : null;
        const langCode = languageCode == null ? 'en' : languageCode;

        await set('resetcode.resetPasswordBusy', true);

        const response = await getValues(get(`roster.data.resetcode.changePassword["${token}"]["${userId}"]["${newCryptoPassword}"]["${langCode}"]`));
        const responseObject = JSON.parse(response);
        const isReturnCodeZero = responseObject.returnCode;
        if (isReturnCodeZero === 0) {
          await set('resetcode.resetPasswordBusy', false);
          await set('resetcode.resetPasswordSuccess', true);
        } else {
          await set('resetcode.resetPasswordBusy', false);
          const returnCode = isReturnCodeZero;
          if (returnCode === 1051) {
            await set('resetcode.errorText', messages['app.auth.validation.noSamePassword']);
          }
        }
      },
    })

    .path('resetcode.resetVariables', {
      call: async ({ _ }, { set }) => {
        await set('auth.userId', null);
        await set('auth.authHeader', null);
        await set('resetcode.resetCodeID', null);
        await set('resetcode.verifyingUsernameAndEmail', false);
        await set('resetcode.showResetCodePage', false);
        await set('resetcode.verifyingResetCode', false);
        await set('resetcode.resetPasswordBusy', false);
        await set('resetcode.resetPasswordSuccess', false);
        await set('resetcode.errorText', null);
        await set('resetcode.wrongResetCodeAttemptCount', 0);
        await set('resetcode.wrongResetCodeAttemptCount', 0);
        await set('resetcode.attemptCountHasExceeded', false);
      },
    })

    .path('resetcode.resetCodeID', variable())
    .path('resetcode.verifyingUsernameAndEmail', variable(false))
    .path('resetcode.showResetCodePage', variable(false))
    .path('resetcode.verifyingResetCode', variable(false))
    .path('resetcode.wrongUserPassword', variable(false))
    .path('resetcode.resetPasswordBusy', variable(false))
    .path('resetcode.resetPasswordSuccess', variable(false))
    .path('resetcode.jwtHeader', variable(null))
    .path('resetcode.errorText', variable(null))
    .path('resetcode.wrongResetCodeAttemptCount', variable(0))
    .path('resetcode.attemptCountHasExceeded', variable(false));
};
